import { OldRecommendationsClanSettingsDialog, RecommendationsClanSettingsDialog } from 'fe2/Containers/';
import { clanIsFull } from "helpers/clan";
import { showAcceptInviteDialog, showSendApplicationDialog } from "helpers/dialog";
import * as React from "react";
import { connect } from "react-redux";
import settings from "settings";
import dwhExport from '~/dwhExport';
import { acceptApplication, changeOrder as changeApplicationsOrder, changePage as changeApplicationsPage, declineApplication, declineApplications, dropSelection, fetchApplications, toggleAllApplicationsPlayersTick, toggleApplicationsPlayerTick } from "../Actions/ActionApp";
import { fetchClan } from '../Actions/ActionClanProfile';
import { hideDialog, showDialog } from '../Actions/ActionDialog';
import { changeOrder as changeInvitesOrder, changePage as changeInvitesPage, declineInvite, fetchInvites, sendInvite } from "../Actions/ActionInvites";
import { changeRequestsBattleType, changeRequestsSeason, changeRequestsTabs } from '../Actions/ActionRequests';
import Requests from "../Components/Requests/Requests";
import { RulesDialog } from '../Components/UIKit/UIKit';
import { openAccountProfile, openChatWindow } from '../web2ClientAPI/web2ClientAPI';

const mapStateToProps = state => {
  const currentAccountClanId = state.currentAccount.clanId;
  const currentClan = state.clans.items[currentAccountClanId];
  const clanLoaded = currentAccountClanId in state.clans.items;

  return {
    root: state.urls.root,
    battleTypes: settings.battleTypes,
    requestsBattleType: state.requests.requestsBattleType,
    requestsSeason: state.requests.requestsSeason,
    requestsSeasonType: state.requests.requestsSeasonType,
    currentAccount: state.currentAccount,
    clan: currentClan,

    isCurrentClanFull: currentClan && clanIsFull(currentClan),
    clanRulesContent: state.content.clansRulesPage,
    clanLoaded,
    invitesEntries: state.invites,
    applicationsEntries: state.applications,
    currentRequestsTab: state.requests.currentRequestsTab,
    selectedApplicationsPlayersIds: state.applications.selectedApplicationsPlayersIds
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onRender: clanId => dispatch(fetchClan(clanId)),
    fetchEntriesByCurrentState: (withGlobalSpinner, tab) => {
      if (tab === 'invites') {
        dispatch(fetchInvites(withGlobalSpinner));
      } else {
        dispatch(fetchApplications(withGlobalSpinner));
      }
    },
    onReloadClick: () => {
      dispatch(fetchInvites());
      dispatch(fetchApplications());
    },

    onSendInvite: account => dispatch(sendInvite(account, true)),
    sendApplication: clan => {
      const source = 'recruitstation';
      const shouldFetchApplications = true;
      dispatch(showSendApplicationDialog(clan, source, shouldFetchApplications));
    },
    onSeasonChange: (selectedSeason, tab) => {
      dispatch(changeRequestsSeason(selectedSeason));
      if (tab === 'invites') {
        dispatch(fetchInvites());
      } else {
        dispatch(fetchApplications());
      }
    },
    onBattleTypeChange: (selectedBattleType, tab) => {
      dispatch(changeRequestsBattleType(selectedBattleType));
      if (tab === 'invites') {
        dispatch(fetchInvites());
      } else {
        dispatch(fetchApplications());
      }
    },
    onAcceptedEntryInvites: invite => dispatch(showAcceptInviteDialog(invite)),
    onDeclinedEntryInvites: invite => dispatch(declineInvite(invite)),

    onApplicationsPlayerTick: playerId => dispatch(toggleApplicationsPlayerTick(playerId)),
    onAllApplicationsPlayersTick: playerIds => dispatch(toggleAllApplicationsPlayersTick(playerIds)),
    onAcceptedEntryApplications: application => dispatch(acceptApplication(application)),
    onDeclinedEntryApplication: application => dispatch(declineApplication(application)),
    onDeclineApplications: () => dispatch(declineApplications()),

    fetchEntriesByPageInvites: page => {
      dispatch(changeInvitesPage(page));
      dispatch(fetchInvites());
    },
    fetchEntriesByPageApplications: page => {
      dispatch(changeApplicationsPage(page));
      dispatch(fetchApplications());
      dispatch(toggleAllApplicationsPlayersTick());
    },
    onSortClickInvites: (order, isAsc) => {
      dispatch(changeInvitesOrder(order, isAsc));
      dispatch(fetchInvites());
    },
    onSortClickApplications: (order, isAsc) => {
      dispatch(changeApplicationsOrder(order, isAsc));
      dispatch(fetchApplications());
    },

    onRulesDialogClick: (content) => dispatch(showDialog((<RulesDialog data={content} onCloseClick={() => dispatch(hideDialog())} />), 'worship')),
    openAccountProfile,
    openChatWindow,
    onToggleTab: (value, canHandleInvites) => {
      if (value === 'invites') {
        if (canHandleInvites) {
            dwhExport.send('requests.clan_requests.view_invites')
        } else {
            dwhExport.send('requests.player_requests.view_invites')
        }
      } else {
        if (canHandleInvites) {
            dwhExport.send('requests.clan_requests.view_requests')
        } else {
            dwhExport.send('requests.player_requests.view_requests')
        }
      }
      dispatch(changeRequestsTabs(value))
    },
    onOldRecommendationsClanSettingsClick: () => dispatch(showDialog((<OldRecommendationsClanSettingsDialog />), 'worship')),
    onRecommendationsClanSettingsClick: () => dispatch(showDialog((<RecommendationsClanSettingsDialog />), 'worship')),
    dropSelection: () => {
      dispatch(dropSelection())
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Requests);